import styled from 'styled-components';

export const Description = styled.div`
  margin: ${({theme: {spacing}}) => `0 ${spacing.s6} ${spacing.s4}`};
`;
